import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";
import { rentalBookings } from "./rental-bookings";
import { rentalReturns } from "./rental-returns";
import { bookingVehicles } from "./booking-vehicles";
import { pickupVehicleLines } from "./pickup-vehicle-lines";
import { vehicles } from "./vehicles";

// ============================================================================
// return_vehicle_lines — ข้อมูลคืนรถรายคันในใบคืนรถเดียวกัน
// ============================================================================
export const returnVehicleLines = sqliteTable("car_rental_return_vehicle_lines", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  returnId: text("return_id").notNull().references(() => rentalReturns.id),
  bookingId: text("booking_id").notNull().references(() => rentalBookings.id),
  bookingVehicleId: text("booking_vehicle_id").references(() => bookingVehicles.id),
  pickupVehicleLineId: text("pickup_vehicle_line_id").references(() => pickupVehicleLines.id),
  vehicleId: text("vehicle_id").notNull().references(() => vehicles.id),
  sortOrder: integer("sort_order").notNull().default(0),

  odometerReading: real("odometer_reading"),
  fuelLevel: text("fuel_level", {
    enum: ["empty", "1/4", "1/2", "3/4", "full"],
  }),
  exteriorCondition: text("exterior_condition"),
  interiorCondition: text("interior_condition"),
  returnRemarks: text("return_remarks"),

  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyReturnIdx: index("rvl_company_return_idx").on(table.companyId, table.returnId),
  companyBookingIdx: index("rvl_company_booking_idx").on(table.companyId, table.bookingId),
  companyVehicleIdx: index("rvl_company_vehicle_idx").on(table.companyId, table.vehicleId),
}));

export type ReturnVehicleLine = typeof returnVehicleLines.$inferSelect;
export type NewReturnVehicleLine = typeof returnVehicleLines.$inferInsert;
